import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { addToastInfo } from '../../../store/common';
import { getBookings } from '../../../services';
import poll from '../../../utils/poll';

const useRedirectToBookings = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { refetch: refetchMyBookings } = useQuery(['my-bookings'], getBookings);

  useEffect(() => {
    const isCalendlyScheduledEvent = (e: any) => {
      return (
        e.data.event &&
        e.data.event.indexOf('calendly') === 0 &&
        e.data.event === 'calendly.event_scheduled'
      );
    };

    const onMessage = (e: any) => {
      if (
        isCalendlyScheduledEvent(e) &&
        history.location.search.includes('offeringId')
      ) {
        onClose();

        dispatch(
          addToastInfo({
            toastInfo: {
              open: true,
              type: 'success',
              content: t('v2.global.snackbar_label_successfulBooking'),
            },
          }),
        );
        poll({
          fn: refetchMyBookings,
        });
        setTimeout(() => {
          history.push('/bookings');
        }, 1500);
      }
    };

    window.addEventListener('message', onMessage);

    return () => window.removeEventListener('message', onMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useRedirectToBookings;
